module.exports = {
    tickets_limit: 5
}